import { useNavigate } from 'react-router-dom'
import { useRecentNotifications, useNotificationMutations } from '@/hooks/api/notifications'
import { NotificationItem } from './NotificationItem'

export function NotificationDropdown({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate()

  const { data, isLoading } = useRecentNotifications(10)
  const { markAsRead, markAllAsRead } = useNotificationMutations()

  function handleItemClick(link: string | null, id: string) {
    markAsRead.mutate(id)
    if (link) navigate(link)
    onClose()
  }

  const items = data?.data ?? []

  return (
    <>
      {/* Neviditeľný backdrop namiesto document mousedown listenera — mobilné
          prehliadače mousedown na nedotykových plochách neemitujú spoľahlivo,
          dropdown sa potom nedal zavrieť. Klik/tap kamkoľvek mimo (vrátane
          zvončeka pod backdropom) panel zavrie. */}
      <div className="fixed inset-0 z-40" onClick={onClose} />
      {/* Na telefóne fixed cez celú šírku pod top barom — absolute right-0 so
          šírkou w-96 pretekal za ľavý okraj displeja (zvonček je v strede lišty). */}
      <div className="fixed inset-x-4 top-16 sm:inset-x-auto sm:absolute sm:right-0 sm:top-full sm:mt-2 sm:w-96 sm:max-w-[calc(100vw-2rem)] bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <span className="font-semibold text-gray-900 dark:text-white">Notifikácie</span>
        <button
          onClick={() => markAllAsRead.mutate()}
          className="text-xs text-brand-600 hover:underline"
        >
          Označiť všetky ako prečítané
        </button>
      </div>

      <div className="max-h-96 overflow-y-auto divide-y divide-gray-100 dark:divide-gray-700">
        {isLoading && <div className="p-6 text-sm text-gray-500 text-center">Načítavam…</div>}
        {!isLoading && items.length === 0 && (
          <div className="p-6 text-sm text-gray-500 text-center">Žiadne notifikácie</div>
        )}
        {items.map((n) => (
          <NotificationItem key={n.id} notification={n} onClick={handleItemClick} compact />
        ))}
      </div>

      <button
        onClick={() => {
          navigate('/notifications')
          onClose()
        }}
        className="w-full px-4 py-3 text-sm font-medium text-brand-600 hover:bg-gray-50 dark:hover:bg-gray-700/50 border-t border-gray-200 dark:border-gray-700 rounded-b-lg"
      >
        Centrum notifikácií →
      </button>
      </div>
    </>
  )
}
